import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Tooltip } from '@delmonicos/shared-design-system-react/src/components/tooltip/tooltip';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface NetworkListIdCellProps
  extends CellContext<GatewayNetworkModel, GatewayNetworkModel['id']> {}

export const NetworkListIdCell = (
  props: NetworkListIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.NETWORK.DETAILS, { id: row.original.id }),
        )
      }
      fullWidth>
      <Tooltip content={getValue()}>
        <Text>{getValue().split('-')[0]}</Text>
      </Tooltip>
    </Link>
  );
};
